import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Slideshow from '../components/Slideshow';
import NewsItem from '../components/NewsItem';
import api from '../services/api';
import { Link } from 'react-router-dom';

const Home = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.getLimitBerita();
      setData(response);
    } catch (err) {
      setError('Gagal memuat data LSP');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Navbar />
      <main>

        <div className="slideshow-container">
          <Slideshow />
        </div>

        <header className="header-banner">
          <h2>SELAMAT DATANG DI KOMITE STANDAR KOMPETENSI KERJA TRANSPORTASI DAN LOGISTIK </h2>

          <div className="marquee">
            <div className="marquee-content">
              KREASI (Kompeten, Responsif, Energik, Adaptif, Sinergi, Informatif)
            </div>
          </div>
        </header>

        <section className="latest-news">
          <h2>BERITA TERKINI</h2>
          <div className="news-container">
            {error && <div className="text-red-600 mb-4">{error}</div>}
            {loading ? (
              <div>Loading...</div>
            ) : (
              data.map((news, index) => (
                <NewsItem
                  key={index}
                  id={news.id}
                  title={news.judul}
                  image={news.gambar}
                  description={news.isi}
                />

              ))
            )}

          </div>
          <div className="see-all">
            <Link className="btn" to="/berita">LIHAT SEMUA</Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Home;
